import { render, staticRenderFns } from "./ShopItemViewer.vue?vue&type=template&id=702470ea&scoped=true&"
import script from "./ShopItemViewer.vue?vue&type=script&lang=js&"
export * from "./ShopItemViewer.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemViewer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopItemViewer.vue?vue&type=style&index=1&id=702470ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702470ea",
  null
  
)

export default component.exports